(() => {
  const xc = document.body.hasAttribute('data-xc-storefront');
  const analyticsAllowed = () => !xc || window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.() === true;
  const marketingAllowed = () => !xc || window.Shopify?.customerPrivacy?.marketingAllowed?.() === true;
  const initialize = () => {
  if (!analyticsAllowed()) return;
  if (window.__niniAnalyticsBridgeReady) return;
  window.__niniAnalyticsBridgeReady = true;

  const config = window.niniAnalyticsConfig || {};
  window.dataLayer = window.dataLayer || [];

  const cleanId = (value) => String(value || '').trim();
  const ga4Id = cleanId(config.ga4MeasurementId);
  const gtmId = cleanId(config.gtmContainerId);
  const metaId = cleanId(config.metaPixelId);
  const tiktokId = cleanId(config.tiktokPixelId);

  const loadScript = (src, id) => {
    if (!src || document.getElementById(id)) return;
    const script = document.createElement('script');
    script.id = id;
    script.async = true;
    script.src = src;
    document.head.appendChild(script);
  };

  const sanitize = (detail = {}) => {
    const payload = {};
    Object.entries(detail).forEach(([key, value]) => {
      if (key === 'event' || key === 'source') return;
      if (value == null) return;
      if (typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean') {
        payload[key] = value;
      }
    });
    return payload;
  };

  const forward = (eventName, detail = {}) => {
    if (!analyticsAllowed()) return;
    const payload = sanitize(detail);
    if (xc && Array.isArray(detail.items)) payload.items = detail.items.map(({ item_id, item_variant, quantity, price_minor }) => ({ item_id, item_variant, quantity, price_minor }));
    if (typeof window.gtag === 'function') {
      window.gtag('event', eventName, payload);
    }
    if (marketingAllowed() && typeof window.fbq === 'function') {
      window.fbq('trackCustom', eventName, payload);
    }
    if (marketingAllowed() && window.ttq && typeof window.ttq.track === 'function') {
      window.ttq.track(eventName, payload);
    }
  };

  if (gtmId) {
    window.dataLayer.push({ 'gtm.start': Date.now(), event: 'gtm.js' });
    loadScript(`https://www.googletagmanager.com/gtm.js?id=${encodeURIComponent(gtmId)}`, 'nini-gtm-loader');
  }

  if (ga4Id) {
    loadScript(`https://www.googletagmanager.com/gtag/js?id=${encodeURIComponent(ga4Id)}`, 'nini-ga4-loader');
    window.gtag = window.gtag || function gtag() {
      window.dataLayer.push(arguments);
    };
    window.gtag('js', new Date());
    window.gtag('config', ga4Id, { send_page_view: false });
  }

  if (marketingAllowed() && metaId && !window.fbq) {
    window.fbq = function fbq() {
      window.fbq.callMethod ? window.fbq.callMethod.apply(window.fbq, arguments) : window.fbq.queue.push(arguments);
    };
    window.fbq.push = window.fbq;
    window.fbq.loaded = true;
    window.fbq.version = '2.0';
    window.fbq.queue = [];
    loadScript('https://connect.facebook.net/en_US/fbevents.js', 'nini-meta-pixel-loader');
    window.fbq('init', metaId);
    window.fbq('track', 'PageView');
  }

  if (marketingAllowed() && tiktokId && !window.ttq) {
    window.ttq = {
      queue: [],
      track() {
        this.queue.push(['track', ...arguments]);
      },
      page() {
        this.queue.push(['page', ...arguments]);
      },
      load(id) {
        this.queue.push(['load', id]);
      },
    };
    loadScript('https://analytics.tiktok.com/i18n/pixel/events.js', 'nini-tiktok-pixel-loader');
    window.ttq.load(tiktokId);
    window.ttq.page();
  }

  const originalPush = window.dataLayer.push.bind(window.dataLayer);
  window.dataLayer.push = function pushWithForwarding(...items) {
    items.forEach((item) => {
      if (item && typeof item === 'object' && typeof item.event === 'string') {
        forward(item.event, item);
      }
    });
    return originalPush(...items);
  };

  const track = (eventName, detail = {}) => {
    const event = {
      event: eventName,
      nini_source: detail.source || 'nini_theme',
      page_path: window.location.pathname,
      page_title: document.title,
      ...detail,
    };
    window.dataLayer.push(event);
    window.dispatchEvent(new CustomEvent('nini:analytics:event:sent', { detail: event }));
  };

  window.addEventListener('nini:analytics:event', (event) => {
    const detail = event.detail || {};
    if (detail.event) track(detail.event, detail);
  });

  document.addEventListener('submit', (event) => {
    if (xc) return;
    const form = event.target;
    if (!(form instanceof HTMLFormElement)) return;
    const action = form.getAttribute('action') || '';
    if (action.includes('/cart/add')) {
      track('nini_add_to_cart_submit', { source: 'product_form' });
    }
  }, true);

  document.addEventListener('click', (event) => {
    if (xc) return;
    const target = event.target.closest('a, button');
    if (!target) return;
    const href = target.getAttribute('href') || '';
    const name = target.getAttribute('name') || '';
    if (href.includes('/checkout') || name === 'checkout') {
      track('nini_begin_checkout_click', { source: 'checkout_cta' });
    }
  }, true);

  const sendPageView = () => {
    track(xc ? 'xc_page_view' : 'nini_page_view', {
      source: 'page',
      canonical_url: document.querySelector('link[rel="canonical"]')?.href || window.location.origin + window.location.pathname,
      ...(xc ? { brand: 'XENITH CORE' } : {}),
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', sendPageView, { once: true });
  } else {
    sendPageView();
  }
  };
  if (xc) document.addEventListener('visitorConsentCollected', initialize);
  initialize();
})();
